<template>
  <div class="notice-container">
    <h2 class="title">{{ title }}</h2>
    <div class="content" v-if="noticeItem" v-html="noticeItem.notice"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    noticeItem: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-container {
  box-sizing: border-box;
  overflow: hidden;
  margin-right: 9px;
  border: 1px solid #A3CBE7;
  border-radius: 10px;
  background-color: #fff;
  .title {
    height: 68px;
    padding: 26px 0 0 28px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #e5e5e5;
  }
  .content {
    padding: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
}
</style>
